// extracted by mini-css-extract-plugin
module.exports = {"label":"File_label__1n48Z","tooltip":"File_tooltip__Uz335","wrap":"File_wrap__25PQQ","input":"File_input__3n57_","box":"File_box__1pm2a"};